import { toast } from "react-toastify";
import api from "../../../api";

function DisconnectEmail({
  closeDisconnectButton,
  closeDisconnectCancelButton,
  setRefresh,
  idEdit,
  emailEdit,
}: any) {
  const handleGroupDelete = async (e: any) => {
    const formData = new FormData();
    formData.append("email_id", idEdit);

    try {
      await api.post(`${process.env.REACT_APP_OUTLOOK_DISCONNECT}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setRefresh((prevRefresh: any) => prevRefresh + 1);
      closeDisconnectButton(e);
      toast.success("Email has been Disconnected successfully!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: "dark",
      });
    } catch (error) {
      toast.error("An error occurred while disconnectring the Email", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: "dark",
      });
      console.log(error);
    }
  };

  return (
    <div
      onClick={closeDisconnectCancelButton}
      role="button"
      className="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-md"
    >
      <div className="bg-[#EDEAF8] rounded-lg shadow-2xl w-[420px]">
        <div className=" flex flex-col ">
          <div>
            <div className="mt-5">
              <span className="p-6 font-semibold">
                Are you sure you want to Disconnect
              </span>
              <br />
              <span className=" p-6 font-bold">{emailEdit}?</span>
            </div>
          </div>
          <div className=" border-b" />
          <div className=" flex flex-row justify-end gap-4 p-6">
            <button
              onClick={closeDisconnectCancelButton}
              className=" bg-white rounded-md p-2 hover:bg-[#b5b1c4]  duration-300"
            >
              Cancel
            </button>
            <button
              onClick={(e: any) => {
                handleGroupDelete(e);
              }}
              className=" bg-red-700 rounded-md p-2 text-white hover:bg-red-900 duration-300"
            >
              Disconnect
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DisconnectEmail;
